/**
 * This will prevent setting css variables with empty string values
 * On pages router empty string values are not handled properly and the server rendered content is different from the client
 * Can be removed once the migration to app router is done
 */
export const getNonEmptyStyleStringValue = (
  value: string | number | undefined,
): string | number | undefined => (value === '' ? undefined : value)
